<template>
    <div class="comment">
        <avatar :avatar="comment.author.avatar" class="avatar"></avatar>
        <div class="comment-header">
            <span class="comment-author">{{ comment.author.name }}</span> &middot; <span class="comment-date">{{ comment.created_at | moment("DD/MM/YYYY") }}</span>
        </div>
        <p class="comment-message">{{ comment.message }}</p>

        <button v-if="depth < 2" class="button clear secondary small reply-button" type="button" @click.prevent="toggleReplyForm()">Atbildēt</button>

        <comment-form v-if="showReplyForm" :materialId="material.id" :reply-to="comment.id" ref="replyForm" @commented="$emit('commented', $event)"></comment-form>

        <comment v-if="comment.replies.length > 0" v-for="c in comment.replies" :key="c.id"
                 :comment="c" :material="material" :depth="depth + 1" class="comment"></comment>
    </div>
</template>

<script>
    import Avatar from '../Avatar'
    import CommentForm from './CommentForm'

    export default {

        name: 'comment',

        props: {
            comment: {
                type: Object,
                required: true
            },
            material: {
                type: Object,
                required: true
            },
            depth: {
                type: Number,
                required: false,
                default: 1
            }
        },

        data() {
            return {
                showReplyForm: false,
            }
        },

        methods: {
            toggleReplyForm() {
                this.showReplyForm = !this.showReplyForm;
                if (!this.showReplyForm) {
                    //TODO reset reply form
                }
            }
        },

        components: { Avatar, CommentForm }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .comment {
        position: relative;
        font-size: rem-calc(14px);
        padding: 1rem 0 0 50px;
        margin: 1rem 0 1rem 0;
        line-height: 1;

        .comment {
            border-top: 1px solid $color-iron-gray;
        }

        .comment-author {
            font-weight: 700;
            font-size: px-em(12px, 14px);
        }

        .comment-date {
            color: $color-gray;
            font-size: px-em(12px, 14px);
        }

        .avatar {
            width: 35px;
            height: 35px;
            position: absolute;
            left: 0;
        }

        .comment-header {
            margin-bottom: 0.5em;
        }

        .comment-message {
            line-height: 1.2;
            margin: 0 0 0.5em 0;
        }

        .reply-button {
            margin: 0;
            padding: 0;
            color: $color-gray;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/comments/Comment.vue